import PageHeader from '@/components/feature/PageHeader';
import Contact from './components/Contact';

export default function ContactPage() {
  return (
    <>
      <PageHeader
        title="Contact"
        subtitle="Notre équipe est à votre écoute pour vous accompagner dans vos expéditions maritimes depuis la Chine."
        image="https://readdy.ai/api/search-image?query=Modern%20logistics%20control%20center%20with%20world%20map%20and%20shipping%20routes%20displayed%20on%20screen%2C%20professional%20maritime%20operations%20desk%20with%20documents%20and%20phone%2C%20warm%20neutral%20tones%2C%20clean%20corporate%20editorial%20photography%20high%20detail&width=1800&height=800&seq=gls-page-contact&orientation=landscape"
      />
      <Contact />
    </>
  );
}